import React, { Component } from 'react'
import connexion from '../../connexion'
import CoverImage from '../UI/CoverImage'
import { Link } from 'react-router-dom'
import picture from '../../img/default.jpg'
import '../Home/Home.css'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid'
import SectionActions from '../UI/SectionActions'
import ThemeIcon from '../UI/ThemeIcon'
import Skeleton from '../UI/Skeleton'


class Pages extends Component
{
	constructor(props)
	{
		super(props)
		this._enter_anim = (props.consumeNavBack && props.consumeNavBack()) ? "page-back-in" : "page-slide-in"
		this.state = {
			page: null,
			service: null,
			mounted: false,
			revealContent: false,
			heights : []
		}
	}

	componentDidMount()
	{
		const wrapper = document.getElementById("wrapper")
		if (wrapper)
			wrapper.scroll(0, 0) //ancre l'animation d'entrée en haut (les fixed/absolute suivent le conteneur transformé)
		this.props.updateLogs(this.props.history.location.pathname, 'Pages')
		this.loadPage()
		this.props.updateShell(null, true, this.props.history.location.pathname)
		if (!this.props.icons)
			this.props.fetchIcons()
		this.props.fetchNotifications()
	}

	componentDidUpdate(prevProps, prevState)
	{
		if (prevProps.pages !== this.props.pages)
			this.loadPage()
		if (prevState.page !== this.state.page)
		{
			const page = this.state.page
			let category = null
			if (this.props.categories && this.props.lists)
			{
				for (let i = 0; i < this.props.categories.length; i++)
				{
					if (this.props.categories[i].type === "list")
					{
						let list = null
						for (let j = 0; j < this.props.lists.length; j++)
						{
							if (this.props.lists[j].category === this.props.categories[i]._id)
							{
								list = this.props.lists[j]
								break
							}
						}
						if (list)
						{
							const elements = list.elements
							for (let j = 0; j < elements.length; j++)
							{
								if (elements[j].page === page._id)
								{
									category = this.props.categories[i]
									break
								}
							}
						}
					}
				}
			}
			let infos = {
				page: page._id,
				from_category: null,
				from_group: null
			}
			if (category)
			{
				let group = null
				infos = {
					...infos,
					from_category: category._id
				}
				if (this.props.groups)
				{
					for (let i = 0; i < this.props.groups.length; i++)
					{
						if (this.props.groups[i]._id === category.group)
						{
							group = this.props.groups[i]
							break
						}
					}
				}
				if (group)
				{
					infos = {
						...infos,
						from_group: group._id
					}
				}
			}
			this.props.updateLogs(this.props.history.location.pathname, 'Pages', infos)
		}
	}

	_loadPageService = (page) => {
		if (page.service && page.service.service && page.service.service !== "precheckin")
		{
			this.props.fetchServiceByID(page.service.service)
			.then(service => {
				this.setState({ page: page, service: service, mounted: true })
			})
		}
		else
			this.setState({ page: page, mounted: true })
	}

	loadPage = () => {
		const pages = this.props.pages
		const length = this.props.lang_assets.paths.pages.length + 1
		const url = this.props.history.location.pathname.substr(length)
		let page = null
		if (pages)
		{
			for (let i = 0; i < pages.length; i++)
			{
				let page_url = ""
				for (let j = 0; j < pages[i].translations.length; j++)
				{
					if (pages[i].translations[j].lang === this.props.user.lang)
					{
						page_url = pages[i].translations[j].url
						break
					}
				}
				if (page_url === url)
				{
					page = pages[i]
					break
				}
			}
			if (page)
			{
				this._loadPageService(page) //cache d'abord : affichage immédiat, revalidation en arrière-plan
				page.timestamp = (page.edited_time) ? page.edited_time : page.created_time
				this.props.fetchPageCheckUpdate(page)
				.then(fetch_page => {
					if (fetch_page !== 1 && fetch_page !== false)
						this._loadPageService(fetch_page)
					else if (fetch_page === 1 && !page.cover && !page.cover_ext)
					{
						this.props.fetchPageByURL(url)
						.then(page => {
							this._loadPageService(page)
						})
						.catch(err => console.log(err))
					}
				})
				.catch(err => {
					console.log("can not check update page", err)
				})
			}
			else
			{
				this.props.fetchPageByURL(url)
				.then(page => {
					this._loadPageService(page)
				})
				.catch(err => console.log(err))
			}
		}
		else
		{
			this.props.fetchPageByURL(url)
			.then(page => {
				this._loadPageService(page)
			})
			.catch(err => console.log(err))
		}
	}

	revealContent = (id, animate) => {
		const div = document.getElementById(id)
		let heights = this.state.heights
		if (div != null)
		{
			let content = div.getElementsByClassName('reveal-on-tap pt-3 pb-5')[0]
			if (heights[id] === undefined)
			{
				const clone = content.cloneNode(true)
				clone.style.cssText = "position: fixed; top -9999px; opacity: 0"
				document.body.appendChild(clone)
				let height = clone.offsetHeight
				height += 20
				clone.parentNode.removeChild(clone)
				height *= 2
				heights[id] = height + "px"
			}
			if (content.style.maxHeight === heights[id]) //section fermée
			{
				content.style.transition = "max-height 0.4s ease, padding-bottom 0.4s ease"
				content.style.paddingBottom = 0
				content.style.maxHeight = 0
				heights = heights.filter((_, index) => index !== id) //Pour vider le tableau des sections fermées
			}
			else
			{
				content.style.transition = (animate === false) ? "none" : "max-height 0.8s ease, padding-bottom 0.8s ease"
				content.style.paddingBottom = "20px"
				content.style.maxHeight = heights[id]
			}
			this.setState({ heights : heights })
		}
	}

	printSection = (title, html, icon, phone, email, website, localisation, facebook, instagram, key) => {
		let jsx = null
		let pictoJSX = null
		let titleJSX = null
		let iconDoc = null
		const icons = this.props.icons
		const theme = this.props.theme
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				iconDoc = icons[i]
				break
			}
		}
		const chevronDown = <ChevronDownIcon className="h-6 w-6 flex-shrink-0"/>
		const chevronUp = <ChevronUpIcon className="h-6 w-6 flex-shrink-0"/>
		const single = (this.state.page && this.state.page.sections && this.state.page.sections.length === 1)
		if (title !== null)
		{
			const alt = "picto " + title
			pictoJSX = (iconDoc !== null) ? <ThemeIcon icon={iconDoc} type="fill" color={'#' + theme.color1} legacyTheme={theme._id} alt={alt} className="w-6 float-left mr-3" /> : null
			titleJSX = 
				<div className="flex justify-between space-x-2 items-start mb-3">
					<p className="font-semibold flex-grow">{title}</p>
					{single ? null : (this.state.heights[key] ? chevronDown : chevronUp)}
				</div>
			jsx = (
				<div className="page bg-white rounded-xl pt-7 px-6 m-5 min-h-20 text-base filter drop-shadow-sm" id={key} key={key} onClick={(single) ? undefined : this.revealContent.bind(this, key)}>
					{pictoJSX} {titleJSX}
					<SectionActions phone={phone} email={email} website={website} localisation={localisation} facebook={facebook} instagram={instagram} labels={this.props.lang_assets.section_actions} color={'#' + theme.color1} />
					<div className={(single) ? "wysiwyg pt-3 pb-5" : "reveal-on-tap wysiwyg pt-3 pb-5"} dangerouslySetInnerHTML={{ __html: html }}></div>
				</div>
			)
		}
		else
		{
			jsx = (
				<div className="page bg-white rounded-xl pt-7 px-6 m-5 min-h-20 text-base filter drop-shadow-sm" id={key} key={key} onClick={(single) ? undefined : this.revealContent.bind(this, key)}>
					<div className={(single) ? "wysiwyg pt-3 pb-5" : "reveal-on-tap wysiwyg pt-3 pb-5"} dangerouslySetInnerHTML={{ __html: html }}></div>
				</div>
			)
		}
		return (jsx)
	}

	render() {
		const page = this.state.page
		if (page && this.props.icons && this.state.mounted)
		{
			let image = (this.state.page.cover || this.state.page.cover_ext) ? connexion.connect.url + 'webapp/pages/cover?id=' + this.state.page._id : null
			if (image === null)
				image = picture
			let pictureJSX = null
			if (image)
			{
				pictureJSX = (
					<CoverImage className="overflow-hidden fixed w-full top-0" src={image} alt="banner" />
				)
			}
			const sections = this.state.page.sections
			let section_k = -1
			let service = null
			if (page.service)
			{
				let title = ""
				for (let j = 0; j < page.service.translations.length; j++)
				{
					if (page.service.translations[j].lang === this.props.user.lang)
					{
						title = page.service.translations[j].title
						break
					}
				}
				const styles = { backgroundColor: '#' + this.props.theme.color1, borderColor: '#' + this.props.theme.color1 }
				console.log("link", page.service)
				if (this.state.service)
				{
					let url = ""
					for (let i = 0; i < this.state.service.translations.length; i++)
					{
						if (this.state.service.translations[i].lang === this.props.user.lang)
						{
							url = this.state.service.translations[i].url
							break
						}
					}
					if (!url) {
						for (let i = 0; i < this.state.service.translations.length; i++) {
							if (this.state.service.translations[i].url) {
								url = this.state.service.translations[i].url
								break
							}
						}
					}
					if (url) {
						url = this.props.lang_assets.paths.services + "/" + url
						service = (<Link to={url}><button type="button" className="service-cta-btn" style={styles}>{title}</button></Link>)
					}
				}
				else if (page.service.service === "precheckin")
					service = (<Link to="/precheckin"><button type="button" className="service-cta-btn" style={styles}>{title}</button></Link>)
				else if (page.service.link)
					service = (<a href={page.service.link}><button type="button" className="service-cta-btn" style={styles}>{title}</button></a>)
			}
			return (
				<div className={this._enter_anim}>
					{pictureJSX}
					{/* <div className="min-h-80 w-full pt-10 p-0 top-40 absolute bg-white rounded-3xl"> */}
					<div className={`contentWrapper bg-gray-100${service ? ' has-sticky-cta' : ''}`}>
						{
							sections.map(({ translations, icon, phone, email, website, localisation, facebook, instagram }) => {
								let title = ""
								let html = ""
								for (let j = 0; j < translations.length; j++)
								{
									if (translations[j].lang === this.props.user.lang)
									{
										title = translations[j].title
										html = translations[j].html
										break
									}
								}
								section_k++
								let ret = this.printSection(title, html, icon, phone, email, website, localisation, facebook, instagram, section_k)
								return (ret)
							})
						}
					</div>
					{service && <div className="sticky-cta-bar">{service}</div>}
				</div>
			)
		}
		else
		{
			return (
				<div className={this._enter_anim}>
					<Skeleton variant="page" />
				</div>
			)
		}
	}
}

export default Pages;